module.exports = __webpack_public_path__ + "static/media/hydorange.b19986f0.svg";